import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useTabsContext } from './tabs-context.esm.js';
import { TAB_THEME_KEY } from './types.esm.js';
import { transitions } from '../../themes/theme-keys/transitions.esm.js';
import { BoxPrivate } from '../_primitives/box/box.esm.js';

var _excluded = ["variant", "className", "orientation", "indicatorPosition", "disableAnimation"];
var TabIndicator = /*#__PURE__*/React.forwardRef(function TabIndicator(props, ref) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'indicator' : _props$variant,
    className = props.className,
    orientation = props.orientation,
    indicatorPosition = props.indicatorPosition,
    disableAnimation = props.disableAnimation,
    other = _objectWithoutProperties(props, _excluded);
  var _useTabsContext = useTabsContext(),
    tabVariant = _useTabsContext.variant;
  var _indicatorPosition = orientation === 'vertical' ? indicatorPosition === 'left' || indicatorPosition === 'right' ? indicatorPosition : 'right' : indicatorPosition === 'top' || indicatorPosition === 'bottom' ? indicatorPosition : 'bottom';
  var __css = useMemo(function () {
    return _objectSpread2({
      position: 'absolute',
      transition: disableAnimation ? 'initial' : transitions.create()
    }, orientation === 'vertical' ? _objectSpread2({
      height: '100%',
      width: '0.2em'
    }, _indicatorPosition === 'right' ? {
      right: 0
    } : {
      left: 0
    }) : _objectSpread2(_objectSpread2({
      height: '0.2em'
    }, _indicatorPosition === 'bottom' ? {
      bottom: 0
    } : {
      top: 0
    }), {}, {
      width: '100%'
    }));
  }, [_indicatorPosition, disableAnimation, orientation]);
  return /*#__PURE__*/React.createElement(BoxPrivate, _extends({
    as: "span",
    ref: ref,
    variant: tabVariant ? "".concat(tabVariant, ".").concat(variant) : variant,
    __themeKey: TAB_THEME_KEY,
    className: classNames('csg-tui-tab-indicator', {
      'is-vertical': orientation === 'vertical'
    }, className)
  }, other, {
    __css: __css
  }));
});

export default TabIndicator;
//# sourceMappingURL=tab-indicator.esm.js.map
